/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_ParticipantRegistrationTypeDto } from '../models/PagedResultDto_ParticipantRegistrationTypeDto';
import type { Wealthlane_CustomerService_Dtos_ParticipantRegistrationType_CreateUpdateParticipantRegistrationTypeDto } from '../models/Wealthlane_CustomerService_Dtos_ParticipantRegistrationType_CreateUpdateParticipantRegistrationTypeDto';
import type { Wealthlane_CustomerService_Dtos_ParticipantRegistrationType_ParticipantRegistrationTypeDto } from '../models/Wealthlane_CustomerService_Dtos_ParticipantRegistrationType_ParticipantRegistrationTypeDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ParticipantRegistrationTypeService {

    /**
     * @returns Wealthlane_CustomerService_Dtos_ParticipantRegistrationType_ParticipantRegistrationTypeDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantRegistrationTypeParticipantRegistrationTypesList(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_ParticipantRegistrationType_ParticipantRegistrationTypeDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant-registration-type/participant-registration-types-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_ParticipantRegistrationType_ParticipantRegistrationTypeDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppParticipantRegistrationType(
requestBody?: Wealthlane_CustomerService_Dtos_ParticipantRegistrationType_CreateUpdateParticipantRegistrationTypeDto,
): CancelablePromise<Wealthlane_CustomerService_Dtos_ParticipantRegistrationType_ParticipantRegistrationTypeDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/participant-registration-type',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_ParticipantRegistrationTypeDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantRegistrationType(
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_ParticipantRegistrationTypeDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant-registration-type',
            query: {
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_ParticipantRegistrationType_ParticipantRegistrationTypeDto OK
     * @throws ApiError
     */
    public static putApiCustomerApiAppParticipantRegistrationType(
id: string,
requestBody?: Wealthlane_CustomerService_Dtos_ParticipantRegistrationType_CreateUpdateParticipantRegistrationTypeDto,
): CancelablePromise<Wealthlane_CustomerService_Dtos_ParticipantRegistrationType_ParticipantRegistrationTypeDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/customer/api/app/participant-registration-type/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiCustomerApiAppParticipantRegistrationType(
id: string,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/customer/api/app/participant-registration-type/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_CustomerService_Dtos_ParticipantRegistrationType_ParticipantRegistrationTypeDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantRegistrationType1(
id: string,
): CancelablePromise<Wealthlane_CustomerService_Dtos_ParticipantRegistrationType_ParticipantRegistrationTypeDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant-registration-type/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
